import { addProdCodeType } from "../../../../../actions/Utilities/ProducerCodeType/index";
import { useMutation } from "react-query";

const useAddProdCodeType = () => {
  return useMutation(addProdCodeType);
};
export default useAddProdCodeType;
